import React from "react";
import ajax from "./../../lib/ajax.js";
import {Button} from "react-bootstrap";
import immutable from "immutable";
import moment from "moment";


class ReasonListItem extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {

        return (
            <div className="ap-reason-item">
                <p>Modified by {this.props.modifiedBy} on {this.props.modifiedDate}</p>                
                <b>Reason:</b><br/>
                {this.props.reason}
            </div>
        );
    }
}

export default class ReasonList extends React.Component {
    constructor(props) {
        super(props);
        this.state = {           
            showMore : false,
            reasons: []
        }

        this.loadReason = this.loadReason.bind(this);
        this.reloadReason = this.reloadReason.bind(this);
    }

    loadReason(timecardId) {  
        const self = this;
        if (this.props.timecardId == timecardId) {            
            const clone = immutable.fromJS(self.state).toJS();           
            const rowIndex = self.state.reasons.length;
            ajax.api()
                .get(`get-change-reasons/${self.props.timecardId}?p=${rowIndex}&pz=6`)
                .then(function(res) {                    
                    for(let i=0; i<res.data.rows.length; i++) {
                        clone.reasons.push(res.data.rows[i]);
                    }
                    clone.showMore = !(clone.reasons.length >= res.data.totalRow);
                    self.setState(clone);
                });
        } else {               
            const clone = immutable.fromJS(self.state).toJS();
            const newState = {
                showMore : false,
                reasons : [],
            };          
            ajax.api()
                .get(`get-change-reasons/${timecardId}?p=0&pz=6`)
                .then(function(res) {                    
                    for(let i=0; i<res.data.rows.length; i++) {
                        newState.reasons.push(res.data.rows[i]);
                    }
                    newState.showMore = !(newState.reasons.length >= res.data.totalRow);
                    self.setState(newState);
                });
        }
    }

    reloadReason(timecardId) {  
        const self = this;
        const clone = immutable.fromJS(self.state).toJS();
        const newState = {
            showMore : false,
            reasons : [],
        };          
        ajax.api()
            .get(`get-change-reasons/${timecardId}?p=0&pz=6`)
            .then(function(res) {                    
                for(let i=0; i<res.data.rows.length; i++) {
                    newState.reasons.push(res.data.rows[i]);
                }
                newState.showMore = !(newState.reasons.length >= res.data.totalRow);
                self.setState(newState);
            });
    }

    componentWillReceiveProps(nextProps) {          
        if (nextProps.timecardId && nextProps.timecardId != this.props.timecardId){
            this.loadReason(nextProps.timecardId);
        } 
    }

    //componentDidMount() {
    //    this.loadReason();
    //}

    render() {         
        const visible = this.state.reasons.length > 0;
        return (
            <div className={visible ? "container" : "container ap-hidden"}>
                <div className="row">
                    <div className="col-md-12 col-lg-12">
                        <div className="ap-bkg-color-gray ap-color-white ap-section-header">
                            <span className="ap-h4">Reason for change</span>
                        </div>
                        <div className="ap-reason-list">
                        {this.state.reasons
                            .filter(r => r.actionType.indexOf("Deleted") === -1 || (r.reason != null && r.reason.trim() != "")) // PMO-1414
                            .map(r => 
                                <ReasonListItem key={r.id} modifiedBy={r.actionOperatorName} reason={r.reason}
                                    modifiedDate={moment(r.actionDate).format("MM/DD/YYYY")}/> )}
                        </div>
                        <div>
                            <Button bsClass={this.state.showMore ? "btn btn-info ap-fullsize ap-top-margined" : "ap-hidden"}
                                    onClick={() => this.loadReason(this.props.timecardId)}>Show more...</Button>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-12"><hr/></div>
                </div>
            </div>
            );
    }
}